import React, { useState } from 'react';
import { ClearOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { AbsoluteLoading } from '@gtintel/platform-atoms';
import { UPLOADED_FILE_ALLOWED_EXTENSIONS } from '@gtintel/platform-constants';
import { ClearButton, DownloadIcon, Spacer, UploadAlert, UploadButtonsContainer, UploadErrorAlert, UploadMaxSize, UploadedItem } from './styles';
const UploadFiles = ({
  uploadDocuments,
  path,
  uploads,
  isDisabled,
  isUserNP,
  isScopeBuilder
}) => {
  const [fileState, setFileState] = useState([]);
  const [failedUploads, setFailedUploads] = useState([]);
  const [totalFiles, setTotalFiles] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState(0);

  // If you upload multiple files at once, this function is called once per file:
  const customRequest = ({
    file
  }) => {
    const rcFile = file;
    const fileExtension = rcFile.name.split('.').slice(-1).pop();
    setTotalFiles(prev => prev + 1);
    if (!UPLOADED_FILE_ALLOWED_EXTENSIONS.includes(fileExtension.toLowerCase())) {
      // macOS puts a file called .DS_Store into directories; if the uploaded
      // dir contains one, we won't upload it but don't need to alert the user
      if (fileExtension !== 'DS_Store') {
        setFailedUploads(currentState => [...currentState, `${rcFile.name} - extension not supported!`]);
      }
      setUploadedFiles(prev => prev + 1);
      return;
    }
    uploadDocuments(rcFile).then(result => {
      if (result.success) {
        setFileState(prev => prev.concat({
          id: uploadedFiles,
          name: path + rcFile.name
        }));
      } else {
        setFailedUploads(currentState => [...currentState, `${rcFile.name} - ${result.message}`]);
      }
      setUploadedFiles(prev => prev + 1);
    });
  };
  const draggerHintText = isDisabled ? "Uploading not permitted within 'Files shared in chat' directory" : 'Drag files or folders here to upload';
  return <div>
      <AbsoluteLoading hideHeader isLoading={uploadedFiles !== totalFiles && totalFiles !== 0} totalFiles={totalFiles} uploadedFiles={uploadedFiles} message="Your files are being uploaded. This might take a while, so please don't leave this page or refresh" />
      <Upload.Dragger name="file" disabled={isDisabled} customRequest={customRequest} openFileDialogOnClick={false} showUploadList={false} withCredentials directory multiple data-testid="doc-upload-files">
        <p className="ant-upload-drag-icon">
          <DownloadIcon />
        </p>
        <p data-public className="ant-upload-hint">
          {draggerHintText}
        </p>
        <Spacer />
      </Upload.Dragger>
      <UploadButtonsContainer>
        <div style={{
        marginRight: 10
      }}>
          <Upload name="upload_folder" multiple showUploadList={false} customRequest={customRequest} directory withCredentials>
            <Button disabled={isDisabled} data-public icon={<UploadOutlined />}>
              Upload Folder
            </Button>
          </Upload>
        </div>
        <div>
          <Upload name="upload_files" multiple showUploadList={false} customRequest={customRequest} withCredentials>
            <Button disabled={isDisabled} data-public icon={<UploadOutlined />}>
              Upload Files
            </Button>
          </Upload>
        </div>
      </UploadButtonsContainer>
      <div data-public>
        <UploadMaxSize data-testid="doc-upload-max-file">
          *The maximum file size for a single file upload is 250MB.
          <br /> If you wish to upload a larger file, please contact a GTI Admin
          for assistance.
        </UploadMaxSize>
        <br />
        {isUserNP && <UploadMaxSize>
            **Please do not upload your final report or any supporting documents
            via the Document Library.
            <br /> Final deliverables should be uploaded via the Report View
            tab.
          </UploadMaxSize>}
      </div>
      <div>
        {fileState.length > 0 && <UploadAlert message={`${uploads} file(s) ${isScopeBuilder ? 'queued and ready for upload' : 'uploaded successfully'}`} type="success" showIcon />}
        {failedUploads.map((item, index) => <UploadErrorAlert key={index} showIcon message={item} type="error" closable />)}
        <div style={{
        marginTop: 10
      }}>
          {fileState.length > 0 && <>
              <b>Uploaded Files:</b>
              <ClearButton data-testid="doc-upload-clear" onClick={() => setFileState([])}>
                <ClearOutlined />
              </ClearButton>
            </>}
        </div>
        <div>
          {fileState.map(item => <UploadedItem data-testid="doc-uploaded-file" key={item?.id}>{`- ${item?.name}`}</UploadedItem>)}
        </div>
      </div>
    </div>;
};
export default UploadFiles;